const OperationType = Object.freeze({
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
});

export default OperationType